import * as THREE from 'three'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import Store from '../store/store'

const commonThreeD = {}
const ratio = 100
const pjType0DesktopR = {
  x: 0,
  y: Math.PI / 2,
  z: 0
}
const pjType0CeilingR = {
  x: 0,
  y: -Math.PI / 2,
  z: Math.PI
}

const pjType1DesktopR = {
  x: 0,
  y: 0,
  z: 0
}
const pjType1CeilingR = {
  x: 0,
  y: 0,
  z: Math.PI
}

const pjType2DesktopR = {
  x: 0,
  y: Math.PI,
  z: 0
}
const pjType2CeilingR = {
  x: 0,
  y: Math.PI,
  z: Math.PI
}

const pjType0DesktopRCurve = {
  x: 0,
  y: 0,
  z: 0
}
const pjType0CeilingRCurve = {
  x: 0,
  y: Math.PI,
  z: Math.PI
}

const pjType1DesktopRCurve = {
  x: 0,
  y: 0,
  z: 0
}
const pjType1CeilingRCurve = {
  x: 0,
  y: 0,
  z: Math.PI
}

const pjType2DesktopRCurve = {
  x: 0,
  y: Math.PI / 2,
  z: 0
}
const pjType2CeilingRCurve = {
  x: 0,
  y: Math.PI / 2,
  z: Math.PI
}
commonThreeD.loadPJModels = async (imgName) => {
  let defaultUrl = 'static/img/3d/'
  var onProgress = function (xhr) {
    if (xhr.lengthComputable) {
    }
  }
  var onError = function (err) { console.log(err) }
  return new Promise((resolve) => {
    return new MTLLoader()
      .setPath(defaultUrl)
      .load(imgName + '.mtl', (materials) => {
        materials.preload()
        return new OBJLoader()
          .setPath(defaultUrl)
          .setMaterials(materials)
          .load(imgName + '.obj', (object) => {
            // 对于 LX04Hver2 模型，是从镜头发出投影射线
            if (imgName !== 'LX04Hver2') {
              object.traverse((child) => {
                if (child instanceof THREE.Mesh) {
                  child.geometry.center()
                  child.geometry.computeBoundingSphere()
                }
              })
            }
            return resolve(object)
          })
      }, onProgress, onError)
  })
}

commonThreeD.createWall = (geometry) => {
  let wallMaterial = new THREE.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.5 })
  let wallEdgesMtl = new THREE.LineBasicMaterial({color: 0xff666666, linewidth: 1})

  let wall = new THREE.Mesh(geometry, wallMaterial)
  let wallEdges = new THREE.EdgesGeometry(geometry)
  let wallLine = new THREE.LineSegments(wallEdges, wallEdgesMtl)
  let wallGroup = new THREE.Group()

  wallGroup.add(wall)
  wallGroup.add(wallLine)
  return wallGroup
}

commonThreeD.createFloor = (width, depth) => {
  let loader = new THREE.TextureLoader()
  let floorImg = loader.load(require('@/assets/parts/graph/floor.png'))

  let geometry = new THREE.PlaneBufferGeometry(width, depth)
  let material = new THREE.MeshBasicMaterial({ map: floorImg, opacity: 0.7, side: THREE.DoubleSide, transparent: true })
  let floor = new THREE.Mesh(geometry, material)
  return floor
}

commonThreeD.setPJModelScale = (type, model, isBlending, curve) => {
  if (!model) return
  if (isBlending) {
    if (type === 0 || type === 1) {
      model.scale.set(0.8, 0.8, 0.8)
    } else if (type === 3) {
      model.scale.set(8, 8, 8)
    } else {
      model.scale.set(0.6, 0.6, 0.6)
    }
  } else if (curve) {
    if (type === 0 || type === 1) {
      model.scale.set(0.025, 0.025, 0.025)
    } else if (type === 3) {
      model.scale.set(0.4, 0.4, 0.4)
    } else {
      model.scale.set(0.01875, 0.01875, 0.01875)
    }
  } else {
    if (type === 0 || type === 1) {
      model.scale.set(0.2, 0.2, 0.2)
    } else if (type === 3) {
      model.scale.set(2, 2, 2)
    } else {
      model.scale.set(0.15, 0.15, 0.15)
    }
  }
}
commonThreeD.getPJModelInitRotation = (type, pos) => {
  let val = {}
  let position = Number(pos)
  switch (type) {
    case 0:
      if (position !== 1) {
        val = pjType0DesktopR
      } else {
        val = pjType0CeilingR
      }
      break
    case 1:
      if (position === 0) {
        val = pjType1DesktopR
      } else {
        val = pjType1CeilingR
      }
      break
    case 2:
      if (position !== 1) {
        val = pjType2DesktopR
      } else {
        val = pjType2CeilingR
      }
      break
    case 3:
      if (position === 0) {
        val = {x: 0, y: Math.PI, z: 0}
      } else if (position === 1) {
        val = {x: 0, y: Math.PI, z: Math.PI}
      } else if (position === 3) {
        val = {x: Math.PI / 2, y: 0, z: Math.PI}
      } else {
        val = {x: -Math.PI / 2, y: 0, z: 0}
      }
      break
    default:
      break
  }
  return val
}
commonThreeD.getCurvePJModelInitRotation = (type, pos) => {
  let position = pos * 1
  let val = {}
  switch (type) {
    case 0:
      if (position !== 1) {
        val = pjType0DesktopRCurve
      } else {
        val = pjType0CeilingRCurve
      }
      break
    case 1:
      if (position === 0) {
        val = pjType1DesktopRCurve
      } else {
        val = pjType1CeilingRCurve
      }
      break
    case 2:
      if (position !== 1) {
        val = pjType2DesktopRCurve
      } else {
        val = pjType2CeilingRCurve
      }
      break
    case 3:
      if (position === 0) {
        val = {x: 0, y: 0, z: 0}
      } else if (position === 1) {
        val = {x: 0, y: 0, z: Math.PI}
      } else if (position === 3) {
        val = {x: Math.PI / 2, y: 0, z: Math.PI}
      } else {
        val = {x: -Math.PI / 2, y: 0, z: 0}
      }
      break
    default:
      break
  }
  return val
}
commonThreeD.setPjModelhAngle = (value, model, type, initVal, pos) => {
  let position = pos * 1
  if (type === 3) {
    if (position === 0 || position === 3) {
      model.rotation.z = initVal.z + value * Math.PI / 180
    } else {
      model.rotation.z = initVal.z - value * Math.PI / 180
    }
  } else {
    model.rotation.y = initVal.y - value * Math.PI / 180
  }
}
commonThreeD.setPjModelvAngle = (value, model, type, initVal) => {
  if (type === 3) {
    model.rotation.x = initVal.x + value * Math.PI / 180
  } else {
    model.rotation.x = value * Math.PI / 180
  }
}
commonThreeD.transCoordToThreeD = (vector, isBlending, info) => {
  let width = isBlending ? info.W : Store.state.houseInfo.roomW
  let depth = isBlending ? info.D : Store.state.houseInfo.roomD
  let height = isBlending ? info.H : Store.state.houseInfo.roomH
  let x = (vector.x - width / 2) / ratio
  let y = (vector.y - depth / 2) / ratio
  let z = (vector.z - height / 2) / ratio
  return new THREE.Vector3(x, -z, y)
}
commonThreeD.transCoordToThreeDX = (val, isBlending, info) => {
  let width = isBlending ? info.W : Store.state.houseInfo.roomW
  return (val - width / 2) / ratio
}
commonThreeD.transCoordToThreeDZ = (val, isBlending, info) => {
  let depth = isBlending ? info.H : Store.state.houseInfo.roomH
  return -(val - depth / 2) / ratio
}
commonThreeD.transCoordToThreeDY = (val, isBlending, info) => {
  let height = isBlending ? info.D : Store.state.houseInfo.roomD
  return (val - height / 2) / ratio
}
export default commonThreeD



// WEBPACK FOOTER //
// ./src/common/commonThreeD.js